import './styles.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'

const ChatNotificationContent = ({ payload, onClick, fallbackTitle }) => {
  const { t } = useTranslation()

  if (!payload) return null

  const { notificationTab, senderAvatar, senderName, communityLogo, communityName, detail, messageData } = payload

  const messageText = messageData?.has_attachments ? (
    <>
      <i className="pi pi-file file-icon"></i>
      {t('SENT_A_FILE')}
    </>
  ) : (
    detail
  )

  if (notificationTab === 'personalChat') {
    return (
      <div className="chat-notification-container" onClick={onClick}>
        <div className="chat-notification-row">
          {senderAvatar && <img src={senderAvatar} alt={senderName} className="chat-notification-avatar" />}

          <div className="chat-notification-content">
            <div className="chat-notification-title">{senderName || fallbackTitle}</div>

            <div className="chat-notification-message">{messageText}</div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="chat-notification-container" onClick={onClick}>
      <div className="chat-notification-row">
        {communityLogo && <img src={communityLogo} alt={communityName} className="chat-notification-avatar" />}

        <div className="chat-notification-content">
          <div className="chat-notification-title">{communityName || fallbackTitle}</div>

          <div className="chat-notification-preview">
            <div className="chat-notification-sender-name">{senderName}:</div>

            <div className="chat-notification-message">{messageText}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChatNotificationContent
